var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{ref:"mapRef",style:(`width: 100%; height: ${_vm.mapHeight === '' ? '400px' : _vm.mapHeight}`),attrs:{"center":{lat: _vm.mLatitude, lng: _vm.mLongitude},"options":_vm.mapOptions(),"zoom":_vm.mZoomLevel,"map-type-id":"terrain"}})
}
var staticRenderFns = []

export { render, staticRenderFns }